import $ from 'jquery';
import config from './config.js';


const togglePassword = {};
const eventType = 'click';

// Toggle Password (show/hide)
togglePassword.setupInForm = function ($form) {
    const $password = $form.find('input[type=password]');
    $form.find('.toggle-password').on(eventType, function () {
        const iconHidePassword = $(this).find('svg')[0];
        const iconShowPassword = $(this).find('svg')[1];
        if ($(iconHidePassword).attr('class') === 'u-show') {
            $password.attr("type", "text");
            $(iconHidePassword).attr('class', 'u-hide');
            $(iconShowPassword).attr('class', 'u-show');
        }
        else if ($(iconHidePassword).attr('class') === 'u-hide') {
            $password.attr("type", "password");
            $(this).removeClass('icon-eye-closed-fill').addClass('icon-eye-stroke');
            $(iconHidePassword).attr('class', 'u-show');
            $(iconShowPassword).attr('class', 'u-hide');
        }
    });
};

export default togglePassword;




// WEBPACK FOOTER //
// ./mobile-core/src/toggle-password.js